import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { SemanticHubGroup, SemanticResolvedLink } from '@/lib/semantic-content/types';

type ResolvedGroup = SemanticHubGroup & {
  resolvedLinks: SemanticResolvedLink[];
};

export default function SemanticNavHub({ groups }: { groups: ResolvedGroup[] }) {
  return (
    <section aria-labelledby="semantic-hub-heading" className="space-y-6">
      <div>
        <h2 id="semantic-hub-heading" className="text-3xl font-semibold tracking-tight text-foreground">
          Explore MapleOS by topic
        </h2>
        <p className="mt-3 max-w-3xl text-base leading-7 text-muted-foreground">
          Browse the semantic docs graph through apps, concepts, and real-world use cases.
        </p>
      </div>

      <div className="grid gap-6 xl:grid-cols-3">
        {groups.map((group) => (
          <Card key={group.title} className="border-border/60 bg-card/60 shadow-none">
            <CardHeader>
              <CardTitle className="text-2xl">{group.title}</CardTitle>
              <p className="text-sm leading-6 text-muted-foreground">{group.description}</p>
            </CardHeader>
            <CardContent>
              <ul className="space-y-3">
                {group.resolvedLinks.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="block rounded-lg px-3 py-2 transition-colors hover:bg-primary/5">
                      <span className="font-medium text-foreground">{link.label}</span>
                      {link.description ? <span className="mt-1 block text-sm leading-6 text-muted-foreground">{link.description}</span> : null}
                    </Link>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
}
